// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"ad0c089b","453":"f7be5b23","535":"9546b0e2","831":"b3e15c0a","846":"6d23162c"}[chunkId] + ".chunk.js";
};